import { render, staticRenderFns } from "./WordingCreate.vue?vue&type=template&id=4ad53491&scoped=true&"
import script from "./WordingCreate.vue?vue&type=script&lang=js&"
export * from "./WordingCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad53491",
  null
  
)

export default component.exports